import { Link } from "react-router-dom";
import { ArrowUpRight, Clock } from "lucide-react";
import { ARTICLES } from "../data/blog";
import { Reveal } from "../components/Reveal";
import { NewsletterSignup } from "../components/NewsletterSignup";

export default function Blog() {
  return (
    <div data-testid="blog-page">
      <section className="pt-32 lg:pt-40 pb-16 px-6 lg:px-12 max-w-7xl mx-auto">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-olive mb-6">Le Journal</p>
          <h1 className="font-serif text-5xl sm:text-6xl font-light tracking-tight text-ink leading-tight max-w-3xl">
            Écrits autour du soin et de la transmission
          </h1>
          <p className="mt-8 text-base sm:text-lg text-sage leading-relaxed max-w-2xl">
            Des articles simples et incarnés pour mieux comprendre la réflexologie, les massages et les approches du corps que je pratique et transmets à Bayonne.
          </p>
        </Reveal>
      </section>

      <section className="pb-24 px-6 lg:px-12 max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-8" data-testid="blog-list">
          {ARTICLES.map((a, i) => (
            <Reveal key={a.slug} delay={(i % 2) * 0.1}>
              <Link
                to={`/blog/${a.slug}`}
                data-testid={`blog-card-${a.slug}`}
                className="group block h-full overflow-hidden rounded-3xl border border-olive-border bg-beige-50 transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_25px_50px_-25px_rgba(49,63,21,0.35)]"
              >
                <div className="overflow-hidden">
                  <img
                    src={a.cover}
                    alt={a.coverAlt}
                    loading="lazy"
                    className="w-full h-60 object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="p-8">
                  <div className="flex items-center gap-4 text-xs uppercase tracking-[0.2em] text-olive">
                    <span>{a.dateLabel}</span>
                    <span className="inline-flex items-center gap-1.5"><Clock className="w-3.5 h-3.5" strokeWidth={1.5} /> {a.readingTime}</span>
                  </div>
                  <h2 className="mt-4 font-serif text-2xl sm:text-3xl text-ink group-hover:text-olive transition-colors duration-300 leading-snug">{a.title}</h2>
                  <p className="mt-4 text-sage leading-relaxed">{a.excerpt}</p>
                  <span className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-olive">
                    Lire l'article <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={1.5} />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      <NewsletterSignup source="blog" />
    </div>
  );
}
